import { action } from '@ember/object';
import type Owner from '@ember/owner';

import type { BlockThemeConfig } from 'webapp-types';

import type { Args as BaseArgs } from 'webapp/components/common/simple-line-chart';
import CommonSimpleLineChartComponent from 'webapp/components/common/simple-line-chart';

import type { CustomColorMap } from 'webapp/models-custom/block-setup';

interface Args extends BaseArgs {
	themeData: BlockThemeConfig.BlockParsed;
	colorIndexOrClass: string | number;
	customColorClassMap?: CustomColorMap;
}

export default class BlockContentNumberAndChartChartComponent extends CommonSimpleLineChartComponent<Args> {
	override heightToWidthRatio = 0.2;

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		this.updateSeriesColorIndexOrClass();
	}

	get themeData() {
		return this.args.themeData;
	}

	override get customColorClassMap() {
		return this.args.customColorClassMap || {};
	}

	protected override updateDataCache() {
		super.updateDataCache();
		this.updateSeriesColorIndexOrClass();
	}

	@action
	updateSeriesColorIndexOrClass() {
		const series = this.args.visualization.series[0];
		if (series) {
			series.colorIndexOrClass = this.args.colorIndexOrClass;
		}
	}
}
